<div
  class="apply-one-style"
  role="navigation"
  aria-label="Navigation Espace Client"
  *ngIf="{isAuthenticated: isAuthenticated$ | async} as model"
>
  <ecm-visitor-header *ngIf="!model.isAuthenticated && !isEclair"></ecm-visitor-header>
  <ecm-sosh-menu *ngIf="(model.isAuthenticated || isEclair) && isSoshMenu"></ecm-sosh-menu>
  <ecm-orange-menu *ngIf="(model.isAuthenticated || isEclair) && !isSoshMenu"></ecm-orange-menu>
</div>
